<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit Video">
      <div class="row">
        <div class="col-md-6 form-group">
          Parent Topic
          <b-form-select v-model="parentTopic" @change="getTopics()" disabled>
            <option
              v-for="(parentTopic, index) in parentTopics"
              :key="index"
              :value="parentTopic.id"
            >
              {{ parentTopic.name }}
            </option>
          </b-form-select>
          <div v-if="parentTopicEmpty" style="color: red">
            Parent topic is required
          </div>
        </div>

        <div class="col-md-6 form-group">
          Topic
          <b-form-select v-model="topic" @change="topicEmpty = false" disabled>
            <option
              v-for="(topic, index) in topics"
              :key="index"
              :value="topic.id"
            >
              {{ topic.name }}
            </option>
          </b-form-select>
          <div v-if="topicEmpty" style="color: red">Topic is required</div>
        </div>

        <div class="col-md-6 form-group">
          Name
          <input
            class="form-control"
            type="text"
            v-model="name"
            @focus="nameEmpty = false"
          />
          <div v-if="nameEmpty" style="color: red">Name is required</div>
        </div>
        <div class="col-md-6 form-group">
          Video URL
          <input
            class="form-control"
            type="text"
            v-model="videoURL"
            @focus="videoURLEmpty = false"
          />
          <div v-if="videoURLEmpty" style="color: red">
            Video URL is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Description
          <input
            class="form-control"
            type="text"
            v-model="description"
            @focus="descriptionEmpty = false"
          />
          <div v-if="descriptionEmpty" style="color: red">
            Description is required
          </div>
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          type="submit"
          @click="editVideo()"
          >Save Changes</b-button
        >
      </div>
    </base-block>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      id: "",
      descriptionEmpty: false,
      videoURLEmpty: false,
      nameEmpty: false,
      description: "",
      videoURL: "",
      name: "",
      topic: "",
      topics: [],
      topicEmpty: false,
      parentTopicEmpty: false,
      parentTopic: "",
      parentTopics: [],
    };
  },
  mounted() {
    this.getParentTopics();
    this.loadData();
  },
  methods: {
    async loadData() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/video/edit/${this.$route.params.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.id = response.data.video.id;
            this.parentTopic = response.data.video.topic.parent.id;
            this.getTopics();
            this.topic = response.data.video.topic.id;
            this.name = response.data.video.name;
            this.videoURL = response.data.video.video_url;
            this.description = response.data.video.description;
          } else {
            this.$swal("Success", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async editVideo() {
      if (this.parentTopic == "") {
        this.parentTopicEmpty = true;
        return;
      }

      if (this.topic == "") {
        this.topicEmpty = true;
        return;
      }

      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }

      if (this.videoURL == "") {
        this.videoURLEmpty = true;
        return;
      }

      if (this.description == "") {
        this.descriptionEmpty = true;
        return;
      }
      let topicIds = [this.parentTopic, this.topic];
      const formdata = new FormData();
      formdata.append("name", this.name);
      formdata.append("video_url", this.videoURL);
      formdata.append("description", this.description);
      formdata.append("topic_id", this.topic);
      formdata.append("topic_ids", topicIds);
      await axios
        .post(
          `${this.$store.getters.baseUrl}/video/update/${this.id}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$swal("Success", "Video updated successfully", "success");
            this.$router.push({name: 'Tables Video'});
            this.parentTopic = "";
            this.topic = "";
            this.name = "";
            this.description = "";
            this.videoURL = "";
            this.topicEmpty = false;
            this.parentTopicEmpty = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async getParentTopics() {
      await axios
        .get(`${this.$store.getters.baseUrl}/topics`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.parentTopics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getTopics() {
      this.parentTopicEmpty = false;
      this.topic = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.parentTopic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.topics = response.data.topics;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>

